// 머리 메타 줄의 「·」 — 폰(md 미만)은 줄이 꺾여 줄 머리에 남으므로 숨기고 간격으로만 가른다.
const MetaSep = () => (
  <span aria-hidden className="hidden md:inline">
    ·
  </span>
);

export default MetaSep;
